import axios from 'axios';
import Entidad from '@/models/Entidad';
import Recibo from '@/models/Recibo';
import Pendiente from '@/models/Pendiente';
import FormaCobro from '@/models/FormaCobro';
import Campo from '@/models/Campo';
import { captureRejectionSymbol } from 'events';
function defaultState() {
	return {
		recibosTable: [],
		recibosTablePendientes: [],
		pendientesSelected: [],
		totalPendientesSelected: 0,
		pendientesTable: [],
		vencidosTable: [],
		formasCobro: [],
		totalAcobrar: 0,
		formularioCobro: {},
		loadingPendientes: true,
		formObservaciones: {
			fecha: new Date(),
			observacion: '',
		},
		files: [],
	};
}
const state = defaultState();
const getters = {};
const mutations = {
	setTableRecibos(state: { recibosTable: Recibo[] }, data: Recibo[] | Recibo) {
		!Array.isArray(data) ? state.recibosTable.push(data) : (state.recibosTable = []);
	},
	setTableRecibosPendientes(state: { recibosTablePendientes: Recibo[] }, data: Recibo[] | Recibo) {
		!Array.isArray(data) ? state.recibosTablePendientes.push(data) : (state.recibosTablePendientes = []);
	},
	setPendientesSelected(state: { pendientesSelected: Recibo[] }, data: Recibo[]) {
		state.pendientesSelected = data;
		//!Array.isArray(data) ? state.pendientesSelected.push(data) : (state.pendientesSelected = []);
	},
	setTotalPendientesSelected(state: { totalPendientesSelected: number }, totalPendientesSelected: number) {
		state.totalPendientesSelected = totalPendientesSelected;
	},
	setTotalAcobrar(state: { totalAcobrar: number }, totalAcobrar: number) {
		state.totalAcobrar = totalAcobrar;
	},
	setPendientesTable(state: { pendientesTable: Pendiente[] }, data: Pendiente | Pendiente[]) {
		!Array.isArray(data) ? state.pendientesTable.push(data) : (state.pendientesTable = []);
	},
	setLoadingPendientes(state: { loadingPendientes: Boolean }, loadingPendientes: Boolean) {
		state.loadingPendientes = loadingPendientes;
	},
	setVencidosTable(state: { vencidosTable: Pendiente[] }, data: Pendiente | Pendiente[]) {
		!Array.isArray(data) ? state.vencidosTable.push(data) : (state.vencidosTable = []);
	},
	setFormasCobro(state: { formasCobro: FormaCobro[] }, formasCobro: FormaCobro[]) {
		state.formasCobro = formasCobro;
	},
	setFormularioCobro(state: { formularioCobro }, formularioCobro) {
		state.formularioCobro = formularioCobro;
	},
	setFile(state: { files }, file) {
		!Array.isArray(file) ? state.files.push(file) : (state.files = []);
	},
};
const actions = {
	async callRecibosTable({ commit, dispatch }, params: { start: number; limit: number; pendientes: boolean }) {
		let pend = params.pendientes ? 1 : 0;
		if (params.start === 0) params.pendientes ? commit('setTableRecibosPendientes', []) : commit('setTableRecibos', []);

		const response = await axios.get(`./api/public/proxy/recibos/getAllRecibos?start=${params.start}&limit=${params.limit}&pendientes=${pend}`);
		if (response.data.items) {
			response.data.items.forEach((element: Recibo) => {
				params.pendientes ? commit('setTableRecibosPendientes', element) : commit('setTableRecibos', element);
			});
			return response.data.items;
		}
	},
	async callPendientesTable({ commit, dispatch }, params: { data: object; start: number; limit: number }) {
		commit('setLoadingPendientes', true);
		commit('setPendientesTable', []);
		commit('setTotalPendientesSelected', 0);
		commit('setPendientesSelected', []);
		commit('setVencidosTable', []);
		const response = await axios.get(`./api/public/proxy/recibos/getAllPendientes`);
		response.data.items.forEach((element: Pendiente) => {
			commit('setPendientesTable', element);
		});
		commit('setLoadingPendientes', false);
		response.data.items.find((element: Pendiente) => {
			if (new Date(element.fecha_venc_id) < new Date()) commit('setVencidosTable', element);
		});
	},
	async callFormasCobro({ commit, dispatch }) {
		const response = await axios.get(`./api/public/proxy/recibos/getAllFormasCobro`);
		if (response.data.items) commit('setFormasCobro', response.data.items);
	},
	async calculaTotal({ commit, dispatch }, fdp) {
		let total = 0;
		fdp.forEach(fp => {
			fp.campos.forEach((campo: Campo) => {
				if (campo.suma && campo.value) {
					let val = campo.value;
					val = val.replace('$', '').replace(/\./g, '').replace(/,/g, '.');
					total = total + parseFloat(val);
				}
			});
		});
		console.log('total a cobrar', total);
		commit('setTotalAcobrar', parseFloat(total.toFixed(2)));
	},

	async savePendientesSelected({ commit, dispatch }, selected) {
		let total = 0;
		selected.forEach(rec => (total = total + parseFloat(rec.importe_saldo)));
		console.log('total pendiente', total);
		commit('setTotalPendientesSelected', parseFloat(total.toFixed(2)));
		commit('setPendientesSelected', selected);
	},

	async callFormularioCobro({ commit, dispatch }) {
		let form = {
			forma: [
				{
					key: 1,
					id: 1,
					metodo: '',
					campos: [
						{
							id: 1,
							label: '',
						},
					],
				},
			],
		};
		commit('setFormularioCobro', form);
	},
	async postRecibo({ commit, dispatch }, cuit) {
		let formData = new FormData();
		for (let i = 0; i < state.files.length; i++) formData.append('files[]', state.files[i]);
		formData.append('formaPago', JSON.stringify(state.formularioCobro['forma']));
		formData.append('comprobantes', JSON.stringify(state.pendientesSelected));
		formData.append('observaciones', JSON.stringify(state.formObservaciones));
		formData.append('totalSeleccionado', JSON.stringify(state.totalPendientesSelected));
		formData.append('totalAcobrar', JSON.stringify(state.totalAcobrar));
		const response = await axios.post('./api/public/proxy/recibos', formData, {
			headers: { 'Content-Type': 'multipart/form-data', 'Access-Control-Allow-Origin': '*', Cooperativa: `${cuit}` },
		});
		return response;
	},
	async saveFile({ commit, dispatch }, file) {
		commit('setFile', file);
	},
	async resetFile({ commit, dispatch }, index) {
		console.log('llega', index, state.files);
		state.files.splice(index, 1);
	},
	reset(): void {
		Object.assign(state, defaultState());
	},
};
export default {
	state,
	getters,
	actions,
	mutations,
};
